import { SettingsSidebar } from '@/components/settings-sidebar'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/settings')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>

        <SidebarProvider className="absolute left-12 top-0 h-full min-h-full">

            <SettingsSidebar className="h-full left-12" />
            <SidebarInset className="bg-background pl-0 mr-13">
                <Outlet />
            </SidebarInset>

        </SidebarProvider>
    </>
}
